import PropTypes from 'prop-types';
import TeamAvailabilityPropType from './teamAvailability';

const TeamsAvailabilityStructureDefaultProps = {
  teamName: '',
  teamAvailability: [],
};

const TeamsAvailabilityStructurePropType = PropTypes.shape({
  teamName: PropTypes.string,
  teamAvailability: PropTypes.arrayOf(PropTypes.shape(TeamAvailabilityPropType)),
});

export default { TeamsAvailabilityStructurePropType, TeamsAvailabilityStructureDefaultProps };
